import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import constant from '../../constant';
import PartyForm from '../ui/partyform';

const EditParty = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [initialValues, setInitialValues] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchParty = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    setError('No authentication token found');
                    return;
                }

                const response = await fetch(`${constant.REACT_APP_API_URL}/party/${id}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });

                const result = await response.json();

                if (response.ok) {
                    const data = result.data[0];
                    setInitialValues(data);
                } else {
                    setError(result.message || 'Failed to fetch party data');
                }
            } catch (error) {
                setError('Error fetching party data');
            } finally {
                setLoading(false);
            }
        };

        fetchParty();
    }, [id]);

    const handleCancel = () => {
        navigate('/parties');
    };


    const handleSubmit = async (partyData) => {
        setLoading(true);
        setError(null);
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                setError('No authentication token found');
                return;
            }
            const response = await fetch(`${constant.REACT_APP_API_URL}/party/${id}`, {
                method: 'PATCH',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(partyData),
            });

            const result = await response.json();

            if (response.ok) {
                navigate('/parties');
            } else {
                setError(result.message || 'Failed to update party');
            }
        } catch (error) {
            setError('Error updating party');
        } finally {
            setLoading(false);
        }
    };


    const handleBack = () => {
        navigate(-1);
    };


    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <Loader2 className="h-8 w-8 animate-spin text-blue-500" />
            </div>
        );
    }
    return (
        <div className="min-h-screen bg-gray-50 p-6 pt-20 md:pt-6">
            <div className="max-w-5xl mx-auto">
                {/* Header */}
                <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                    <div className="flex items-center space-x-4">
                        <button onClick={handleBack} className="text-gray-500 hover:text-gray-700 transition-colors">
                            <ArrowLeft className="h-6 w-6" />
                        </button>
                        <h2 className="text-2xl font-bold text-gray-800">Edit Party</h2>
                    </div>
                </div>
                {loading && (
                    <div className="bg-blue-50 text-blue-700 p-4 rounded-lg mb-6">
                        Processing...
                    </div>
                )}
                        {error && (
          <div className="bg-red-50 text-red-700 p-4 rounded-lg mb-6">
            {error}
          </div>
        )}
                <PartyForm
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    onCancel={handleCancel}
                    isEditMode={true}
                />
            </div>
        </div>
    );
};

export default EditParty;